import React, { useCallback } from 'react';
import Button from './Button';
import { FormattedMessage } from 'react-intl';
import { useAppContext } from '../../context/AppContext';
import { TransactionSearchRequestContextActions } from '../../context/actions/transactionSearchRequestContextActions';
import {ViewContextActions} from "../../context/actions/viewContextActions";

type Props = {
  className: string;
};

const ButtonTryAgain = ({ className }: Props) => {
  const { viewDispatch, transactionSearchRequestDispatch } = useAppContext();
  const handleTryAgain = useCallback(() => {
    viewDispatch({
      type: ViewContextActions.ShowMainTransactionDataFormView,
    });
    transactionSearchRequestDispatch({
      type: TransactionSearchRequestContextActions.clearAll,
    });
  }, [viewDispatch, transactionSearchRequestDispatch]);

  return (
    <Button
      name="try_again"
      className={className}
      onClick={handleTryAgain}
      text={<FormattedMessage id="formData.tryAgainButton" />}
      disabled={false}
      type={'button'}
    />
  );
};

export default ButtonTryAgain;
